jQuery( document ).ready(function($) {

    $('.productchoice_button').click(function(){

        gtag('event', 'conversion', {'send_to': 'AW-689097416/SVH8CJmp6sgBEMiVy8gC'});
        gtag('event', 'click', {event_category: 'ajout_panier'});
        fbq('track', 'AddToCart');
        console.log("gtag('event', 'conversion', {'send_to': 'AW-689097416/SVH8CJmp6sgBEMiVy8gC'});");
        console.log("gtag('event', 'click', {event_category: 'ajout_panier'});");
        console.log("fbq('track', 'AddToCart');");

    });

    $('button[name="woocommerce_checkout_place_order"]').click(function() {

        fbq('track', 'InitiateCheckout');
        gtag('event', 'conversion', {'send_to': 'AW-689097416/OZNnCMO328gBEMiVy8gC'});
        gtag('event', 'click', {event_category: 'InitiateCheckout'});
        console.log("fbq('track', 'InitiateCheckout');");
        console.log("gtag('event', 'conversion', {'send_to': 'AW-689097416/OZNnCMO328gBEMiVy8gC'});");
        console.log("gtag('event', 'click', {event_category: 'InitiateCheckout'});");

    });

    if($('.woocommerce_gallery').length > 0) {
        jQuery('.woocommerce_gallery').owlCarousel({
            loop: true,
            nav: false,
            dots: true,
            navText : ["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"],
            responsive:{
                0:{
                items: 1,
                dots: true,
                },
            }
        })
    }

    /* $('.add_to_cart_button').on('click', function(e) {
      var id = $(this).attr('data-id');
      console.log(id);
      e.preventDefault();
      $(this).prop('disabled', true);
      $(this).html('Veuillez patienter...');
      addToCart(id);
      return false;
    })

    function addToCart(p_id) {
        $.get('/?add-to-cart=' + p_id, function() {
            window.location.href = '/panier'
        });
    } */
    
});